module.exports = __webpack_public_path__ + "static/media/page-title.49e3c4ff.jpg";